export default __webpack_public_path__ + "static/media/lbj.ef02e032.png";